var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list-view"},[_c('h1',[_vm._v(" Добавить пользователя ")]),_c('manager-add-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }